$(document).ready(function(){
  $('.featured-collections2__sort .select-label').click(function(){
      $(this).parent().toggleClass('open');
  });
  $('.featured-collections2__sort .select-options li').click(function(){
    $('.featured-collections2__sort .select-options li').removeClass('active');
    $(this).addClass('active');
    var v = $(this).data('value');
    $(this).parent().parent().removeClass('open');
    $('.featured-collections-carousel').attr('data-sort', v);
  });

  $('.collection-navigation__slider').slick({
    dots: false,
    infinite: true,
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    prevArrow: '<div class="arrow-left"><svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.912071 12.6099L7 6.52201L0.912072 0.434082" stroke="black" fill="none"></path></svg></div>',
    nextArrow: '<div class="arrow-right"><svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.912071 12.6099L7 6.52201L0.912072 0.434082" stroke="black" fill="none"></path></svg></div>',
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });
  
  $('.ArticleHighlight__Slider').slick({
    dots: false,
    infinite: true,
    arrows: true,
    centerMode: true,
    centerPadding: '100px',
    swipeToSlide: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: '<div class="arrow-left"><svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.912071 12.6099L7 6.52201L0.912072 0.434082" stroke="black" fill="none"></path></svg></div>',
    nextArrow: '<div class="arrow-right"><svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.912071 12.6099L7 6.52201L0.912072 0.434082" stroke="black" fill="none"></path></svg></div>',
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: '40px',
        }
      }
    ]
  });

  $('.Article__ProductSlider').slick({
      dots: false,
      infinite: true,
      arrows: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow: '<div class="arrow-left"><svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.912071 12.6099L7 6.52201L0.912072 0.434082" stroke="black" fill="none"></path></svg></div>',
      nextArrow: '<div class="arrow-right"><svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.912071 12.6099L7 6.52201L0.912072 0.434082" stroke="black" fill="none"></path></svg></div>',
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 700,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
    setTimeout(function(){
      $(".Article__ProductItem .ProductItem__Slider .flickity-viewport").css("height", $(".Article__ProductItem").width());
    }, 500);

  $('.shop-now__carousel').slick({
    dots: false,
    infinite: true,
    arrows: true,
    swipeToSlide: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: '<div class="arrow-left"><svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.912071 12.6099L7 6.52201L0.912072 0.434082" stroke="black" fill="none"></path></svg></div>',
    nextArrow: '<div class="arrow-right"><svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.912071 12.6099L7 6.52201L0.912072 0.434082" stroke="black" fill="none"></path></svg></div>',
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.shop-more__carousel').slick({
    dots: false,
    infinite: true,
    arrows: true,
    swipeToSlide: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: '<div class="arrow-left"><svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.912071 12.6099L7 6.52201L0.912072 0.434082" stroke="black" fill="none"></path></svg></div>',
    nextArrow: '<div class="arrow-right"><svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.912071 12.6099L7 6.52201L0.912072 0.434082" stroke="black" fill="none"></path></svg></div>',
    responsive: [
      {
        breakpoint: 1140,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.prev-next-blog-posts').slick({
    dots: false,
    infinite: true,
    arrows: true,
    swipeToSlide: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: '<div class="arrow-left"><svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.912071 12.6099L7 6.52201L0.912072 0.434082" stroke="black" fill="none"></path></svg></div>',
    nextArrow: '<div class="arrow-right"><svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.912071 12.6099L7 6.52201L0.912072 0.434082" stroke="black" fill="none"></path></svg></div>',
    responsive: [
      {
        breakpoint: 1150,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  
  $('.product-share-button').click(function(){
    var $this = $(this);
    $this.find('.ShareLink_share_tooltip_wrapper__qS5hO').css('opacity', '1');
    $this.find('.ShareLink_share_tooltip_wrapper__qS5hO').css('z-index', '1');
    setTimeout(function(){
      $this.find('.ShareLink_share_tooltip_wrapper__qS5hO').css('opacity', '0');
      $this.find('.ShareLink_share_tooltip_wrapper__qS5hO').css('z-index', '-1');
    }, 3000);
  });

  if($.session.get("NewsletterPopup") == 'hide'){
    $(".NewsletterPopup__Button").addClass("hide");
  }else{
    $(".NewsletterPopup__Button").removeClass("hide");
  }
  $(".NewsletterPopup__Button-container").click(function(){
    $(this).parent().addClass("hide");
    $(".newsletter-popup").addClass("open");
  });
  $(".NewsletterPopup__Button-close").click(function(){
    $(this).parent().addClass("hide");
    $.session.set("NewsletterPopup", "hide");
  });
  $(".pop-in__close-button").click(function(){
    $(".NewsletterPopup__Button").removeClass("hide");
    $(".newsletter-popup").removeClass("open");
  });

  $('.social-floating .newsletter-floating').click(function(){
    $(".NewsletterPopup__Button-container").trigger('click');
  });

  $('a[href*="#newsletter"]').click(function(){
      $('.header__menu-disclosure').removeAttr('open');
      $('.header__menu-disclosure').attr('aria-expanded', 'false');
      $('.NewsletterPopup__Button-container').trigger('click');
  });

  var h = $('.collection .product-list .product-card:first-child').height();
  $('.Promo__Image img').css('height', h);
  $('.product-card__banner-last-list .banner-last-list__image img').css('height', h);

  $('.pagination__link').click(function(){
    setTimeout(function(){
      var h = $('.collection .product-list .product-card:first-child').height();
      $('.Promo__Image img').css('height', h);
      $('.product-card__banner-last-list .banner-last-list__image img').css('height', h);
    }, 2000);
  });

  var speed = $('.product-card__promo-slider').data('autoplayspeed');
  $('.product-card__promo-slider').slick({
    dots: false,
    infinite: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: speed,
    slidesToShow: 1,
    slidesToScroll: 1
  }); 
  var height_banner = $('.collection .product-list .product-card:first-child').height();
  $('.collection .ProductItem__Banner .Banner__Image').height(height_banner);

  $('.iwts__wrapper').slick({
    dots: true,
    infinite: true,
    arrows: false,
    adaptiveHeight: true,
    slidesToShow: 1,
    slidesToScroll: 1
  });
  $('.iwts__tab').click(function(){
    $('.iwts__tab').removeClass('active');
    $(this).addClass('active');
    var i = $(this).data('index');
    $('.iwts__wrapper').slick('slickGoTo', i-1);
  });

  var html = $('.template-collection .shopify-section--collection-list').html().replace(/\s+/g, '');
  var b = $('.template-collection .breadcrumb__list li').length;
  console.log(html+'/'+b);
  if(html==='' && parseInt(b)==4){
    //$('.template-collection .breadcrumb__list li:nth-child(3)').css('display', 'none');
  }
});

$(window).resize(function(){
  $('.shop-now__carousel').slick('slickAdd');

  var h = $('.collection .product-list .product-card:first-child').height();
  $('.Promo__Image img').css('height', h);
  $('.product-card__banner-last-list .banner-last-list__image img').css('height', h); 
  var height_banner = $('.collection .product-list .product-card:first-child').height();
  $('.collection .ProductItem__Banner .Banner__Image').height(height_banner);
});

$(window).scroll(function(){
  var h = $('#main .shopify-section:first-child').height() / 2;
  if ($(window).scrollTop() > h) {
    $('.social-floating').show();
  }else{
    $('.social-floating').hide();
  }
});

window.addEventListener('load', () => {
  if($(window).width() < 1008){
    const interval = setInterval(() => {
      const chatWidget = document.querySelector('inbox-online-store-chat');
      chatWidget.shadowRoot.querySelector('.chat-toggle').onclick = function() {
        document.querySelector('.newsletter-popup').classList.remove('open');
      }
  
      if (chatWidget && chatWidget.shadowRoot) {
        const style = document.createElement('style');
        style.textContent = `
          button.chat-toggle {
            height: 34px !important;
            width: 34px !important;
          }
          button.chat-toggle svg{
            height: 32px !important;
          }
        `;
        chatWidget.shadowRoot.appendChild(style);
        clearInterval(interval);
      }
    }, 500);
  }else{
    const interval = setInterval(() => {
      const chatWidget = document.querySelector('inbox-online-store-chat');
      chatWidget.shadowRoot.querySelector('.chat-toggle').onclick = function() {
        document.querySelector('.newsletter-popup').classList.remove('open');
      }
  
      if (chatWidget && chatWidget.shadowRoot) {
        const style = document.createElement('style');
        style.textContent = `
          button.chat-toggle {
            height: 40px !important;
            width: 40px !important;
            padding: 0 !important;
            border-radius: 50% !important;
            max-width: none !important;
          }
          button.chat-toggle .chat-title{
          display: none !important;
          }
          button.chat-toggle svg{
            height: 38px !important;
          }
        `;
        chatWidget.shadowRoot.appendChild(style);
        clearInterval(interval);
      }
    }, 500);
  }

  $(".btn-chat").click(function(){
    const chatWidget = document.querySelector('inbox-online-store-chat');
    chatWidget.shadowRoot.querySelector('.chat-toggle').click();
  });
});

    document.querySelectorAll('.per-page-options li').forEach(item => {
      item.addEventListener('click', function () {
        const limit = this.getAttribute('data-limit');
        const url = new URL(window.location.href);
        const lang = $('html').attr('lang');

        if(lang == 'de'){
          const oldParams = Array.from(url.searchParams.entries());
          if(oldParams.length > 0){
            url.search = "";
            url.searchParams.set('limit', limit);
            for (const [key, value] of oldParams) {
              if (key !== "a") {
                url.searchParams.append(key, value);
              } 
            }
          }
        }else{
          url.searchParams.set('limit', limit);
          url.searchParams.set('page', 1);
        }

        window.location.href = url.toString();
      });
    });

    var swiper = new Swiper( '.swiper-container.two', {
      pagination: '.swiper-pagination',
      paginationClickable: true,
      effect: 'coverflow',
      loop: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      coverflow: {
        rotate: 0,
        stretch: 100,
        depth: 150,
        modifier: 1.5,
        slideShadows : false,
      }
    });

    document.querySelector('.swiper-button-next').addEventListener('click', () => {
      swiper.slideNext();
    });
    document.querySelector('.swiper-button-prev').addEventListener('click', () => {
      swiper.slidePrev();
    });